import s from "./background.module.css";
import {
    fifthStepBackground,
    finishBackground,
    firstStepBackground,
    fourthStepBackground,
    thirdStepBackground
} from "../../../../assets";

const Background = (props) => {
    // Destructured props
    const {currentStep} = props;

    // An enum containing the background image for each step
    const IMG_ENUM = {
        1: firstStepBackground,
        2: firstStepBackground,
        3: thirdStepBackground,
        4: fourthStepBackground,
        5: fifthStepBackground,
        6: finishBackground
    }

    return (
        <div className={"flex flex-row justify-center w-full md:w-max shrink-0"}>
            <img
                src={IMG_ENUM[currentStep]}
                className={`${s.image} ${s.fadeIn}`}
                alt="Background image"
            />
        </div>
    )
}

export default Background;
